/**
 * 用户管理
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
	async getFormDetail(keyId) {
		return request(api.comm.USER + "/" + keyId, METHOD.GET);
	},
	async saveFormDetail(result) {
		return request(api.comm.USER, METHOD.POST, result);
	},
	async getMenuList(keyId='') {
		return request(api.comm.DEPT + "?parentId=" + keyId, METHOD.GET, {"filter.eq.isUse":1});
	},
	async setPassword(result) {
			return request(api.comm.USER + '/updatePassword', METHOD.POST, result)
	},
	async adminUpdatePassword(result) {
			return request(api.comm.USER + '/adminUpdatePassword', METHOD.POST, result)
	},
	async getDealerList() {
		return request(api.temp.BASE_URL + '/ec/dealer/all', METHOD.GET);
	},


}


export default {dataApi}